// @ts-nocheck
import config from "constants/config";

export function getEmployeeAuthorisation(companyId) {
  if (!companyId) {
    return Promise.resolve([]);
  }
  const response = useGet(`/realms/${config.realm}/qjumpers/companies/${companyId}/employeeauthorisation`, "KEYCLOAK");
  return response;
}

import { useGet } from "./useRequest";

export const useGetCompanyDetails = (userId) => {
  const response = useGet(`/realms/${config.realm}/qjumpers/users/${userId}/companies`, "KEYCLOAK");
  return response;
};

export function getOrganisationCheck(companyId) {
  if (!companyId) {
    return Promise.resolve([]);
  }
  const response = useGet(`/organisations/check/${companyId}`);
  return response;
}

export function getOrganisation(companyId) {
  if (!companyId) {
    return Promise.resolve([]);
  }
  const response = useGet(`/organisations/${companyId}`);
  return response;
}

export function getBrowserToken(employerId) {
  const response = useGet(`/authentication/${employerId}/browsertoken`);
  return response;
}
